import RMExchangePlatformModal from './RM_exchange_platform-modal.vue'
export default RMExchangePlatformModal
